import React, { useState } from 'react';
import { DangerousHTML } from './DangerousHTML';
import { Button, ButtonModes } from './Button';
import { useIsVisible } from '../hooks';

const classNames = require('html-classnames');

export interface JoinCTAProps {
  joinCTA: {
    image: string,
    imageAlt: string,
    headline: string,
    text: string,
    button: string,
  }
}

export const JoinCTA: React.FC<JoinCTAProps> = (props) => {
  const [node, setNode] = useState<HTMLElement | undefined | null>(undefined);
  const visible = useIsVisible(node, 0.5, true);

  const mainClassNames = classNames('join-cta', {
    '--visible': visible,
  });

  return (
    <section className="join-cta__wrapper" ref={setNode}>
      <div className={mainClassNames}>
        <div className="join-cta__image">
          <img src={props.joinCTA.image} alt={props.joinCTA.imageAlt} />
        </div>
        <DangerousHTML element="h3" html={props.joinCTA.headline} />
        <DangerousHTML element="p" html={props.joinCTA.text} className="join-cta__text" />
        <p className="join-cta__button">
          <Button url="https://dolacz.partiarazem.pl" withBigEffect mode={ButtonModes.primary}>
            {props.joinCTA.button}
          </Button>
        </p>
      </div>
    </section>
  );
};


export default JoinCTA;
